import { memo, useEffect } from 'react'
import styled from 'styled-components'
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router-dom';

import map from './UI/icons/MapIcon.svg'
import arrow from './UI/icons/arrow.svg'
import { MAIN_COLORS } from '../../UI/consts/colors';
import Mascot_ball from '../../UI/consts/Mascot_ball.json'
import CoinIcon from '../../UI/icons/Coin.svg'

import { $userInfoBd, $userInfoTg } from '../../components/store/user';
import { getUserRaiting } from '../../components/store/leaders';

import Stories from './UI/components/Stories';
import Balance from '../BonusList/UI/components/Balance';
import AllCollection from './UI/components/AllCollection';
import Achievements from './UI/components/Achievements';
import Button from '../../UI/components/UIKit/Button';
import GifCard from '../../UI/components/UIKit/GifCard';
import { AnimatedList } from '../../UI/components/UIKit/AnimationDiv';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap:24px;
    padding-top: 40px;
`
const Flex = styled.div`
    display: flex;
    gap: 8px;
`
const Column = styled.div`
    display:flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;
    text-align: left;

    h1,h2 {
        color: ${MAIN_COLORS.yellow}
    }

    .pink {
        color: ${MAIN_COLORS.pink}
    }
`
const TitleList = () => {
    const navigate = useNavigate();
    const user = useUnit($userInfoTg);
    const userBd = useUnit($userInfoBd);
    
    useEffect(() => {
        window.Telegram.WebApp.BackButton.hide();
        getUserRaiting();
    },[]);

  return (
    <Wrapper>
        <AnimatedList>
            <Stories/>
            <Flex>
                <div style={{ flex: 1 }}>
                    <Balance activateBalanceModal={() => navigate('/BonusPage')}/>
                </div>
                <Column>
                    <Button onClick={()=>{navigate('/MapPage')}} style={{ padding: '18px 19px', justifyContent:'flex-start', gap: '4px',background: `${MAIN_COLORS.purple_300}` }}>
                        <h2 style={{ color: '#ffffff'}}>Карта</h2>
                        <img
                            src={map}
                            alt=""
                        />
                    </Button>
                    <Button onClick={()=>{navigate('/LeadersPage')}} style={{ padding: '15px 8px', justifyContent:'flex-start',background: `${MAIN_COLORS.purple_300}` }}>
                        <Column style={{ gap: 0 }}>
                            <h2 style={{ color: '#ffffff'}}>Рейтинг</h2>
                            <h2 style={{ fontSize: '24px', color: `${MAIN_COLORS.yellow}` }}>{user?.raiting || '100+'}</h2>
                        </Column>
                    </Button>
                </Column>
            </Flex>
            {!userBd?.bonus_account?.card_number && 
                <GifCard
                    gif={Mascot_ball}
                    text={'Привяжи свою карту и получай бесплатные крутки!'}
                    onClick={() => navigate('/BonusPage')}
                    button={
                        <div style={{display:'flex', gap: '8px', alignItems:'center'}}>
                            <span style={{
                                    background:`${MAIN_COLORS.gradient_yellow_pink}`,
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text'
                                }}
                            ><h2>+100</h2></span>
                            <img src={CoinIcon} alt=""/>
                        </div>  
                    }
                />
            }
            <Button onClick={()=>{navigate('/MissionsPage')}} style={{ padding: '12px', justifyContent:'space-between', width: '100%' }}>
                <Column>
                    <h2>Задания</h2>
                    <h4 className='pink'>Выполняй задания и получай бесплатные крутки!</h4>
                </Column>
                <img
                    src={arrow}
                    alt=""
                />
            </Button>
            <AllCollection/>
            <Achievements/>
        </AnimatedList>
    </Wrapper>
  )
}

export default memo(TitleList)
